'use strict';

var util = require('../util/utils');
var formValidation = require('base/components/formValidation');

/**
 * Validate file size of uploaded file is less than specified limit
 * @param {Object} file - the uploaded file
 * @returns {boolean} true/false
 */
function validateFileSize(file) {
    var isValid = true;
    var fileSize = file.size / 1024 / 1024; // in MB
    if (fileSize > 20) {
        isValid = false;
    }
    return isValid;
}

/**
 * Validate file extension of uploaded file
 * @param {Object} file - the uploaded file
 * @returns {boolean} true/false
 */
function validateFileExtension(file) {
    var regex = {
        fileExtension: /\.(jpg|jpeg|png|pdf|tiff)$/
    };
    var validationResult = regex.fileExtension.test(file.name);
    return validationResult;
}

/**
 * Handle updating file name field
 */
function handleUpdateFilenameField() {
    var $fileInput = $('.file-input-handler');
    var $fileNameInput = $('.js-file-name-input');
    var $businessCard = $('.businessCard');
    var filename = $fileInput.val().replace(/^.*\\/, '');
    if (filename) {
        $('.upload-button').prop('disabled', false);
    } else {
        $('.upload-button').prop('disabled', true);
    }
    $fileNameInput.val(filename);
    $businessCard.val(filename);
    $(document.activeElement).blur();
}

/**
 * @param {string} e - event
 */
function handleRemoveButtonClick(e) {
    e.preventDefault();
    $($(this).parent).find('.uploaded-file-wrapper').each((_e, element)=>{
        if (!$(element).hasClass('template')) {
            $(element).remove();
        }
    });
    $('.upload-button').removeClass('d-none');
    $('.file-input-handler').removeClass('d-none');
    $('.uploaded-file-wrapper.template').removeClass('d-none');
    $('.approvedFiles').find('.remove').addClass('d-none');
}

/**
 * @param {string} $file - file
 */
function copyFileInput($file) {
    var $fileCopy = $file.clone();
    var uuid = (new Date()).getTime();
    var inputName = $fileCopy.prop('name') + uuid;
    var fileName = $file.get(0).files[0].name;

    $fileCopy.removeClass('file-input-handler');
    $fileCopy.addClass('uploaded-file-input d-none');

    $fileCopy.prop('name', inputName);
    $fileCopy.prop('id', inputName);

    var $result = $fileCopy.wrap(function () {
        var $this = $(this);
        var $newParent = $('.uploaded-file-wrapper.template').clone().removeClass('template');
        $newParent.find('.name').text(fileName);
        return $newParent.append($this);
    }).closest('.uploaded-file-wrapper');

    $result.appendTo($('.approvedFiles'));

    // clear original input to avoid duplicate files
    if ($file.get(0).files.length === $fileCopy.get(0).files.length) {
        $file.val('');
    }
    handleUpdateFilenameField();
    $('.upload-button').prop('disabled', true);
    $('.upload-button').addClass('d-none');
    $('.file-input-handler').addClass('d-none');
    $('.uploaded-file-wrapper.template').addClass('d-none');
    $('.approvedFiles').find('.remove').removeClass('d-none');
}

/**
 * @param {string} e - event
 */
function handleUploadButtonClick(e) {
    e.preventDefault();
    var $file = $('.file-input-handler');
    if (validateFileSize($file.get(0).files[0])) {
        if (validateFileExtension($file.get(0).files[0])) {
            copyFileInput($file);
        } else {
            alert($('.error-message-file-type').text());
            $file.val('');
            handleUpdateFilenameField();
        }
    } else {
        alert($('.error-message-file-size').text());
        $file.val('');
        handleUpdateFilenameField();
    }
}

/**
 *
 * @param {string} code - preapproval code
 */
function processApprovalCode(code) {
    // caching applicantType
    const applicantTypeValue = $('#applicantType').val();
    if (!applicantTypeValue === code) {
        $('#code').addClass('is-invalid');
    }
}

/**
 * @param {string} e - event
 */
function preApprovalCodeCheck(e) {
    e.preventDefault();
    $('#applyBtn').attr('disabled', false);
    var url = $(this).data('validate');
    var formData = {
        code: $('#code').val(),
        applicantType: $('#applicantType').val()
    };
    if (formData.code) {
        $.ajax({
            type: 'POST',
            url: url,
            data: formData
        }).always(function (response) {
            if (response.success) {
                if (!response.proDealApplicantType) return;
                processApprovalCode(response.proDealApplicantType);
                console.log(response.proDealApplicantType);
            } else if (!response.success) {
                $('#code').addClass('is-invalid');
                $('#code').next('.invalid-feedback').text(response.message);
                $('#applyBtn').attr('disabled', true);
            }
        });
    }
}
/**
 * @param {string} e - event
 */
function handleFormSubmit(e) {
    e.preventDefault();
    var $form = $(this);
    var url = util.appendCSRFTokenToURL($('.prodealSubmitUrl').val(), $form);
    var data = new FormData(this);
    $form.spinner().start();

    $.ajax({
        type: 'POST',
        enctype: 'multipart/form-data',
        url: url,
        processData: false,
        contentType: false,
        cache: false,
        data: data
    }).always(function (response) {
        if (response.success || (response.responseText && !response.responseText.error)) {
            window.location.href = $('.prodealShowUrl').val();
        } else if (response.errorType && response.errorType === 'password') {
            $('.invalid-password-error').text(response.errorMessage);
            $('.invalid-password-error').removeClass('d-none');
            var position = $('.password') && $('.password').length ? $('.password').offset().top : 0;
            var scrollTo = position.toFixed();
            $('html, body').animate({
                scrollTop: scrollTo
            }, 500);
        } else {
            if (response.fields) {
                formValidation($form, response);
                var fieldkeys = Object.keys(response.fields);
                $('html, body').animate({
                    scrollTop: $('input[name*="' + fieldkeys[0] + '"]').offset().top.toFixed()
                }, 500);
                $('input[name*="' + fieldkeys[0] + '"]').focus();
            }
            if (response.errorMessage) {
                $('.prodeal-error-messaging-base').text(response.errorMessage);
                $('.prodeal-error-messaging-base').removeClass('d-none');
            }
        }
        $form.spinner().stop();
    });
}

/**
 * Initialize events
 */
function initializeEvents() {
    $('.file-input-handler').on('change', handleUpdateFilenameField);
    $('input[name="dwfrm_prodeal_prodealbase_code"]').on('blur', preApprovalCodeCheck);
    $('.upload-button').on('click', handleUploadButtonClick);
    $('.approvedFiles').on('click', '.remove', handleRemoveButtonClick);
    $('body').on('submit', '.prodealform-submit', handleFormSubmit);
    if ($('#form-applicantType').length) {
        $('#form-applicantType option:selected')[0].value = 'Select Applicant Type';
    }
    $(document).ready(function () {
        $('#prodealModal').modal('show');
    });
}

module.exports = {
    init: function () {
        initializeEvents();
    },
    prodeal: function () {
        $('#form-applicantType').on('change', function (e) {
            e.preventDefault();
            var form = $(this).closest('form');
            if ($('#form-applicantType option:selected')[0].value !== 'Select Applicant Type') {
                if ($('#form-applicantType option:selected')[0].value === 'retail') {
                    $(form).find('.applicantRoleRetail-form-group').removeClass('d-none');
                    $(form).find('.applicantRoleIndustry-form-group').addClass('d-none');
                    $(form).find('.applicantRoleGovernment-form-group').addClass('d-none');
                    $(form).find('#form-applicantRoleRetail').removeAttr('disabled');
                } else if ($('#form-applicantType option:selected')[0].value === 'industry') {
                    $(form).find('.applicantRoleRetail-form-group').addClass('d-none');
                    $(form).find('.applicantRoleIndustry-form-group').removeClass('d-none');
                    $(form).find('.applicantRoleGovernment-form-group').addClass('d-none');
                    $(form).find('#form-applicantRoleIndustry').removeAttr('disabled');
                } else if ($('#form-applicantType option:selected')[0].value === 'government') {
                    $(form).find('.applicantRoleRetail-form-group').addClass('d-none');
                    $(form).find('.applicantRoleIndustry-form-group').addClass('d-none');
                    $(form).find('.applicantRoleGovernment-form-group').removeClass('d-none');
                    $(form).find('#form-applicantRoleGovernment').removeAttr('disabled');
                }
            } else {
                $(form).find('#form-applicantRoleRetail').attr('disabled', true);
                $(form).find('#form-applicantRoleIndustry').attr('disabled', true);
                $(form).find('#form-applicantRoleGovernment').attr('disabled', true);
                $(form).find('#form-applicantRoleRetail').prop('selected', false);
                $(form).find('#form-applicantRoleIndustry').prop('selected', false);
                $(form).find('#form-applicantRoleGovernment').prop('selected', false);
            }
        });
    }
};
